import React from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'

const Cancellation = () => {
    return (
        <>
            <Header />
            <section className='ourServices'>
                <div className="container">
                    <div className="osLeft" style={{width:"100%"}}>
                        <h2>Cancellation and Refund Policy</h2>
                    </div>
                    {/* <div className="osRight">
                        <p style={{ marginBottom: "0px" }} >Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>

                    </div> */}
                </div>
            </section>
            <section className='blogContentArea'>

                <div className="container">
                    <div className="blogContent">
                        <p>
                        Last updated: December 17, 2024
                        </p>
                        <p>
                        At I-LINE.AI SOLUTIONS PRIVATE LIMITED, we strive to provide seamless and efficient 
services through our platform, iLine.ai. This Cancellation and Refund Policy outlines the terms 
and conditions governing the cancellation of services and associated refunds. By using our 
platform, you agree to this policy.
                        </p>
                    </div>
                    <div className="blogContent">
                        <h2>Cancellation Policy
                        </h2>
                        <p><strong style={{ color: "#172039" }}>Cancellation by the User:</strong></p>
                        <ol>
                            <li>Users can cancel a booking through the iLine.ai platform prior to the initiation of the 
                            service</li>
                            <li>Cancellation charges may apply based on the timing of the cancellation:</li>
                        </ol>
                        <ul className='Bullets' style={{paddingLeft:"100px"}}>
                            <li><strong style={{ color: "#172039" }}>Before dispatch:</strong> No cancellation charges.</li>
                            <li><strong style={{ color: "#172039" }}>After dispatch but before pickup:</strong> 50% of the base fee.
                            </li>
                            <li><strong style={{ color: "#172039" }}>After pickup or during transit:</strong> Full base fee plus any applicable additional 
                            charges.</li>
                        </ul>
                    </div>

                    <div className="blogContent">
                        <h2>Cancellation by the Company:
                        </h2>
                        <ol>
                            <li>-LINE.AI SOLUTIONS PRIVATE LIMITED reserves the right to cancel bookings under the 
following circumstances:
</li>
<ul className='Disc' style={{paddingLeft:"100px"}}>
                            <li>
                            Non-compliance with our Terms and Conditions.
                            </li>
                            <li>
                            Incorrect or misleading information provided by the User.
                            </li>
                            <li>Incorrect or misleading information provided by the User.</li>
                        </ul>
                        <li>
                            In such cases, Users will be notified immediately, and any applicable refunds will be 
                            processed as per the refund terms outlined below.
                            </li>
                            
                        </ol>
                        
                    </div>

                    <div className="blogContent">
                        <h2> Refund Policy
                        </h2>
                        <p>
                        <strong style={{ color: "#172039" }}>Refund Eligibility:</strong>

                        </p>
                        <p>
                        Refunds will be processed under the following conditions but final take on the refunds will only 
                        be taken by <strong style={{ color: "#172039" }}>I-LINE.AI SOLUTIONS PRIVATE LIMITED.</strong>
                        </p>
                        <ol>
                            <li>If the service is cancelled by the Company due to operational constraints.
                            </li>
                            <li>If the User cancels the booking prior to the dispatch of the vehicle.
                            </li>
                            <li>If the service could not be delivered due to technical failures attributable to the 
                            Company.</li>
                        </ol>
                    </div>

                    <div className="blogContent">
                        <h2>Non-Refundable Charges:</h2>
                        <p>
                        The following charges are non-refundable:
                        </p>
                        <ol>
                            <li>Cancellation charges as specified in Section 1.1.
                            </li>
                            <li>
                            Any additional fees incurred for specific requests, such as express delivery or add-on 
                            services.
                            </li>
                            <li>
                            Government taxes, tolls, or other mandatory surcharges.
                            </li>
                        </ol>
                    </div>

                    <div className="blogContent">
                        <h2>Refund Processing:
                        </h2>
                        <ol>
                            <li>Refunds will be initiated within 7-10 business days from the date of cancellation 
approval.
</li>
<li>The refund amount will be credited to the original payment method used by the User.</li>
<li>
For payments made through third-party payment gateways, the refund timeline is 
subject to the processing times of the respective gateway provider.

</li>
                        </ol>
                    </div>

                    <div className="blogContent">
                        <h2>Exceptional Cases
                        </h2>
                        <p><strong style={{ color: "#172039" }}>Force Majeure:</strong></p>
                        <p>
                        Refunds or cancellations due to events beyond the control of I-LINE.AI SOLUTIONS PRIVATE 
                        LIMITED, including but not limited to natural disasters, strikes, pandemics, or governmentimposed restrictions, will be handled on a case-by-case basis at the Company’s discretion.
                        </p>
                    </div>
                    <div className="blogContent">
                    <h2>Disputes:</h2>
                    <p>If a User disputes a cancellation or refund decision, they can reach out to our support team at:</p>
                    <ul>
                        <li><strong style={{ color: "#172039" }}>Email:</strong> info@iline.ai</li>
                        <li><strong style={{ color: "#172039" }}>Address:</strong> D-9, Sector-3, Noida, Gautam Buddha Nagar, Uttar Pradesh, India-201301
                        </li>
                    </ul>
                    <p>The Company will review and resolve disputes within 15 business days of receiving the 
complaint. Any further actions or legal proceedings will be governed by applicable laws under 
the jurisdiction of Noida, Uttar Pradesh, India.</p>
                    </div>

                    <div className="blogContent">
                        <h2>Final Provisions</h2>
                        <p><strong style={{ color: "#172039" }}>Updates to the Policy:</strong></p>
                        <p>
                        I-LINE.AI SOLUTIONS PRIVATE LIMITED reserves the right to modify or update this Cancellation 
                        and Refund Policy at any time. Users are advised to review this policy periodically.
                        </p>

                    </div>

                    <div className="blogContent">
                        <p><strong style={{ color: "#172039" }}>Contact Us:</strong></p>
                        <p>For further assistance, please contact our support team at:</p>
                        <ul className='Bullets'>
                            <li><strong>Email:</strong> info@iline.ai
                            </li>
                            <li>
                            <strong>Address:</strong> D-9, Sector-3, Noida, Gautam Buddha Nagar, Uttar Pradesh, India-201301

                            </li>
                        </ul>
                        <p>
                        By using the iLine.ai platform, you acknowledge that you have read, understood, and agree to 
                        this Cancellation and Refund Policy.
                        </p>
                    </div>
                </div>

            </section>
            <Footer />

        </>
    )
}

export default Cancellation
